import React, { ReactElement } from 'react';
import Modal from 'react-bootstrap/esm/Modal';

import PageScrollerNavigation from './PageScrollerNavigation';

type Props = {
    closeModal: Function;
    children: ReactElement;
    show?: boolean;
};

function PageScrollerModal({ closeModal, children, show = true }: Props) {
    return (
        <Modal size="xl" scrollable show={show}>
            <div className="modal-header">
                <div>
                    <PageScrollerNavigation />
                </div>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => closeModal()}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">{children}</div>
        </Modal>
    );
}

export default PageScrollerModal;
